import { Subject } from 'rxjs'
import apiResponse from '../../../../../../services/apiResponse'
import CreateRepository from '../Repositories/CreateRepository'


class CreateBloc {

    regionProvinceChannel = new Subject();
    regionCityChannel = new Subject();
    createChannel = new Subject();
    repository = new CreateRepository()
    listPegawaiChanel = new Subject();

    constructor() {
        this.createChannel.next({status: apiResponse.INITIAL})
    }

    fetchRegionProvince = async (query) => {
        try {
            this.regionProvinceChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchRegionProvince(query).then((result) => {
                this.regionProvinceChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.regionProvinceChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'channel unsubscribed')   
        }
    }

    fetchRegionCity = async (query) => {
        try {
            this.regionCityChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchRegionCity(query).then((result) => {
                this.regionCityChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.regionCityChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'channel unsubscribed')   
        }
    }

    fetchCreate = async (query) => {
        try {
            this.createChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchCreate(query).then((result) => {
                this.createChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.createChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'channel unsubscribed')   
        }
    }

    fetchPegawai = async (query) => {
        this.listPegawaiChanel.next({status: apiResponse.LOADING})
        await this.repository.fetchPegawai(query).then((result) => {
            this.listPegawaiChanel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.listPegawaiChanel.next({status: apiResponse.ERROR, data: error})
        })
    }
}

export default CreateBloc